<template>
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div>
                    <p class="bold dp-inblock h-30px font-23 mb-20 w-300px">상세 및 기타</p>
                    <a class="float-right layer-close ml-30 pointer" @click="$emit('close')">
                        <img src="../../../assets/img/close.png" alt="close" class="close-btn">
                    </a>
                    <div>
                        <span class="font-13 bold">클래스: {{subjectName}}</span>
                    </div>
                    <div class="mt-10 mb-10">
                        <textarea disabled v-model="text" class="w-100per h-150px"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: ['etc'],

    data: () => ({
        text: '',
        subjectName: ''
    }),

    mounted () {
        this.text = this.etc.etc
        this.subjectName = this.etc.subjectName
    },

    methods: {

    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
